import { defineComponent as t, computed as r, createElementBlock as c, openBlock as a, normalizeStyle as n, renderSlot as d } from "vue";
const u = /* @__PURE__ */ t({
  __name: "Badge",
  props: {
    color: {}
  },
  setup(e) {
    const o = r(
      () => e.color ? {
        "--badge-background-color": e.color,
        "--badge-text-color": `color-mix(in srgb, ${e.color}, black 40%)`
      } : {}
    );
    return (l, s) => (a(), c("div", {
      class: "badge",
      style: n(o.value)
    }, [
      d(l.$slots, "default", {}, void 0, !0)
    ], 4));
  }
});
export {
  u as default
};
